import {route} from '@/router/route-utils'

const prefix = '/society';

const routes = [

    route(
        prefix + '/dashboard', 'society.dash', {
            components : {
                main: () => import('./views/SocietyDashView')
            },
            requiresAuth: true,
            layout: 'LayoutFull',
            title: 'Dashboard',
            breadcrumb: [
                {text: 'Dashboard', active: true},
            ],
        }
    ),

    route(
        prefix + '/matches/request/:id', 'society.matches.request', {
            components : {
                main: () => import('../society-matches/views/SocietyMatchesRequestView')
            },
            requiresAuth: true,
            layout: 'LayoutFull',
            title: 'Partite',
            breadcrumb: [
                {text: 'Partite', to: {name: 'society.matches'}},
                {text: 'Richiesta',  to: {name: 'society.matches'}},
                {text: 'Richiesta', active: true},
            ],
        }
    ),

];

export default routes
